<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M12.5011 6.75C12.5448 6.75009 12.5875 6.75447 12.6291 6.76172C12.6829 6.77107 12.7361 6.78549 12.7873 6.80664C12.8102 6.81619 12.8309 6.8301 12.8527 6.8418C12.916 6.87572 12.977 6.91634 13.0304 6.96973C13.1444 7.08367 13.2122 7.22546 13.2375 7.37305C13.2445 7.41438 13.2502 7.45665 13.2502 7.5L13.2492 11.9551C13.2492 12.3693 12.9134 12.7051 12.4992 12.7051C12.0853 12.7046 11.7492 12.369 11.7492 11.9551V9.31152L2.47477 18.5859C2.18189 18.8788 1.7071 18.8787 1.41422 18.5859C1.12135 18.2931 1.12138 17.8183 1.41422 17.5254L10.6896 8.25H8.04411C7.63005 8.24981 7.29411 7.9141 7.29411 7.5C7.29411 7.0859 7.63005 6.75019 8.04411 6.75H12.5011Z"
            fill="currentColor"
        />
        <path
            d="M13.6105 1.19434C15.2525 1.19434 16.5831 2.52506 16.5832 4.16699V14.7217C16.5832 16.3637 15.2525 17.6943 13.6105 17.6943H8.05485C7.64097 17.6939 7.30485 17.3583 7.30485 16.9443C7.30491 16.5304 7.64101 16.1947 8.05485 16.1943H13.6105C14.4241 16.1943 15.0832 15.5352 15.0832 14.7217V4.16699C15.0831 3.35348 14.424 2.69434 13.6105 2.69434H6.9445C6.13116 2.69455 5.47191 3.35362 5.47184 4.16699V10.2773C5.47184 10.6916 5.13605 11.0273 4.72184 11.0273C4.30781 11.0271 3.97184 10.6914 3.97184 10.2773V4.16699C3.97191 2.52519 5.30273 1.19455 6.9445 1.19434H13.6105Z"
            fill="currentColor"
        />
    </svg>
</template>
